import axios from 'axios';

const api = axios.create({
  baseURL:
    process.env.REACT_APP_BASE_API_URL ||
    process.env.REACT_APP_API_URL ||
    'http://localhost:3000',
  timeout: 120000,
});

api.interceptors.request.use((config) => {
  try {
    const isSalesAdminRequest = String(config.url || '').includes('/sales-admin/');
    const raw = localStorage.getItem(isSalesAdminRequest ? 'sales_admin_auth' : 'auth_state');
    if (raw) {
      const parsed = JSON.parse(raw) as { token?: string };
      if (parsed?.token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${parsed.token}`;
      }
    }
  } catch {}
  return config;
});

export default api;
